export default {
  setSearchText (state: {[key:string]: string}, payload: string) {
    state.searchText = payload
  },
  setSearchSensorText (state: {[key:string]: string}, payload: string) {
    state.searchSensorText = payload
  },
  setCurrentPage (state: {[key:string]: number}, page: number) {
    state.currentPage = page
  },
  setOrderName (state: {[key:string]: string}, name: string) {
    state.orderName = name
  },
  setSortAsc (state: {[key:string]: boolean}, sort: boolean) {
    state.sortAsc = sort
  }
}
